export default "__VITE_ASSET___fV_1ExG__"